import axios from "axios";
import config from "./config";

const BASE_URL = config.baseApi;

const customAxios = axios.create({
  baseURL: BASE_URL,
  headers: {
    "ngrok-skip-browser-warning": "69420",
  },
});

const requestHandler = (request) => {
  request.headers["ngrok-skip-browser-warning"] = "69420";

  const userStr = localStorage.getItem("signova-admin");

  if (userStr) {
    try {
      const userData = JSON.parse(userStr);
      const token = userData?.data?.accessToken || userData?.data?.token || userData?.accessToken || userData?.token;
      if (token) {
        request.headers.Authorization = `Bearer ${token}`;
      }
    } catch (e) {
      console.error("Error parsing user data from localStorage:", e);
    }
  }
  return request;
};

const responseHandler = (response) => {
  if (response.status === 401) {
    localStorage.removeItem("signova-admin");
    window.location.href = "/login";
  }
  return response;
};

const requestErrorHandler = (error) => {
  return Promise.reject(error);
};

const responseErrorHandler = (error) => {
  if (error.response) {
    if (error.response.status === 401) {
      localStorage.removeItem("signova-admin");
      window.location.href = "/login";
      return Promise.reject(error);
    }
  }
  return Promise.reject(error);
};

customAxios.interceptors.request.use(
  (request) => requestHandler(request),
  (error) => requestErrorHandler(error),
);

customAxios.interceptors.response.use(
  (response) => responseHandler(response),
  responseErrorHandler,
);

export default customAxios;
